var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import ReviewItem from "../ReviewItem";
export var ReviewList = function (_a) {
    var _b = _a.reviews, reviews = _b === void 0 ? [] : _b, onReply = _a.onReply, onLike = _a.onLike, onReport = _a.onReport;
    if (!(reviews === null || reviews === void 0 ? void 0 : reviews.length)) {
        return (_jsx("div", __assign({ className: "text-center py-8 text-gray-500" }, { children: "\u307E\u3060\u30EC\u30D3\u30E5\u30FC\u306F\u3042\u308A\u307E\u305B\u3093" })));
    }
    return (_jsx("div", __assign({ className: "container mx-auto" }, { children: _jsx("div", __assign({ className: "flex flex-col gap-4" }, { children: reviews === null || reviews === void 0 ? void 0 : reviews.map(function (review, index) { return (_jsx(ReviewItem, { index: index + 1, review: review, onReply: onReply, onLike: onLike, onReport: onReport }, review.id)); }) })) })));
};
